export default "__VITE_ASSET__f02bef11__"